export const API_TO_UI_KEY_MAP = {
    au_manage_relationships: 'CanRecieveAUManageRelationships',
    au_manage_contracts: 'CanRecieveAUManageContracts',
    au_manage_users_added_new_user: 'CanRecieveAUManageUsersAddedNewUser',
    au_manage_users_unassigned_workkards: 'CanRecieveAUManageUsersUnassignedWorkkards',
    au_manage_users_unassigned_activities: 'CanRecieveAUManageUsersUnassignedActivities',
    au_made_owner_todo: 'CanRecieveAUMadeTodoOwner',
    au_edit_todo: 'CanRecieveAUEditTodo',
    au_todo_reminder: 'CanRecieveAUTodoReminder',
    au_workkard_note_added: 'CanRecieveAUWorkkardNoteAdded',
    au_workkard_note_with_file_only_added: 'CanRecieveAUWorkkardNoteWithFileOnlyAdded',
    au_workkard_edit: 'CanRecieveAUWorkkardEdit',
    au_workkard_close: 'CanRecieveAUWorkkardClose',
    au_workkard_watcher: 'CanRecieveAUWorkkardWatcher',
    au_activity_accepted_or_rejected: 'CanRecieveAUActivityAcceptedOrRejected',
    au_activity_note_added: 'CanRecieveAUActivityNoteAdded',
    au_activity_note_with_file_only_added: 'CanRecieveAUActivityNoteWithFileOnlyAdded',
    au_activity_status_change: 'CanRecieveAUActivityStatusChange',
    au_activity_completed: 'CanRecieveAUActivityCompleted',
    au_activity_closed: 'CanRecieveAUActivityClosed',
    au_activity_reopened: 'CanRecieveAUActivityReopened',
    au_activity_edit: 'CanRecieveAUActivityEdit',
    au_activity_owner: 'CanRecieveAUActivityOwner',
    au_activity_assignee: 'CanRecieveAUActivityAssignee',
    au_activity_watcher: 'CanRecieveAUActivityWatcher',
    au_new_owner_activity: 'CanRecieveAUNewOwnerActivity',
    au_new_assignee_activity: 'CanRecieveAUNewAssigneeActivity',
    au_new_assignee_organization_activity: 'CanRecieveAUNewAssigneeOrganizationActivity',
    au_request_to_join_org: 'CanRecieveAURequestToJoinOrg',
    au_request_when_user_added: 'CanRecieveAURequestWhenUserAdded',
    au_change_sponsor: 'CanRecieveAUChangeSponsor',
    au_you_are_sponsor_workkard: 'CanRecieveAUYouAreSponsorWorkkard',

    email_notify_manage_relationships: 'CanRecieveEmailNotificationManageRelationships',
    email_notify_manage_contracts: 'CanRecieveEmailNotificationManageContracts',
    email_notify_manage_users_added_new_user: 'CanRecieveEmailNotificationManageUsersAddedNewUser',
    email_notify_manage_users_unassigned_workkards: 'CanRecieveEmailNotificationManageUsersUnassignedWorkkards',
    email_notify_manage_users_unassigned_activities: 'CanRecieveEmailNotificationManageUsersUnassignedActivities',
    email_notify_made_owner_todo: 'CanRecieveEmailNotificationMadeTodoOwner',
    email_notify_edit_todo: 'CanRecieveEmailNotificationEditTodo',
    email_notify_todo_reminder: 'CanRecieveEmailNotificationTodoReminder',
    email_notify_workkard_note_added: 'CanRecieveEmailNotificationWorkkardNoteAdded',
    email_notify_workkard_note_with_file_only_added: 'CanRecieveEmailNotificationWorkkardNoteWithFileOnlyAdded',
    email_notify_workkard_edit: 'CanRecieveEmailNotificationWorkkardEdit',
    email_notify_workkard_close: 'CanRecieveEmailNotificationWorkkardClose',
    email_notify_workkard_watcher: 'CanRecieveEmailNotificationWorkkardWatcher',
    email_notify_activity_accepted_or_rejected: 'CanRecieveEmailNotificationActivityAcceptedOrRejected',
    email_notify_activity_note_added: 'CanRecieveEmailNotificationActivityNoteAdded',
    email_notify_activity_note_with_file_only_added: 'CanRecieveEmailNotificationActivityNoteWithFileOnlyAdded',
    email_notify_activity_status_change: 'CanRecieveEmailNotificationActivityStatusChange',
    email_notify_activity_completed: 'CanRecieveEmailNotificationActivityCompleted',
    email_notify_activity_closed: 'CanRecieveEmailNotificationActivityClosed',
    email_notify_activity_reopened: 'CanRecieveEmailNotificationActivityReopened',
    email_notify_activity_edit: 'CanRecieveEmailNotificationActivityEdit',
    email_notify_activity_owner: 'CanRecieveEmailNotificationActivityOwner',
    email_notify_activity_assignee: 'CanRecieveEmailNotificationActivityAssignee',
    email_notify_activity_watcher: 'CanRecieveEmailNotificationActivityWatcher',
    email_notify_new_owner_activity: 'CanRecieveEmailNotificationNewOwnerActivity',
    email_notify_new_assignee_activity: 'CanRecieveEmailNotificationNewAssigneeActivity',
    email_notify_new_assignee_organization_activity: 'CanRecieveEmailNotificationNewAssigneeOrganizationActivity',
    email_notify_request_to_join_org: 'CanRecieveEmailNotificationRequestToJoinOrg',
    email_notify_when_user_added: 'CanRecieveEmailNotificationWhenUserAdded',
    email_notify_change_sponsor: 'CanRecieveEmailNotificationChangeSponsor',
    email_notify_you_are_sponsor_workkard: 'CanRecieveEmailNotificationYouAreSponsorWorkkard'
};

export const UI_TO_API_KEY_MAP = Object.entries(API_TO_UI_KEY_MAP).reduce((acc, [apiKey, uiKey]) => {
    acc[uiKey] = apiKey;
    return acc;
}, {});

// Converts a full API response (73 fields) into the legacy UI-shaped settings object
// consumed by manageNotifications.jsx / constants.js. Non-toggle fields (metadata,
// au_filter, user_theme, and the 6 "other" fields) are preserved as-is under their
// original API key since the UI does not render them.
export const mapApiToUi = (apiSettings = {}) => {
    const uiSettings = {};
    Object.entries(apiSettings).forEach(([apiKey, value]) => {
        const uiKey = API_TO_UI_KEY_MAP[apiKey];
        uiSettings[uiKey || apiKey] = value;
    });
    return uiSettings;
};

// Converts a partial set of changed UI-keyed fields into the API's partial PUT body.
export const mapUiDiffToApi = (uiDiff = {}) => {
    const apiDiff = {};
    Object.entries(uiDiff).forEach(([uiKey, value]) => {
        const apiKey = UI_TO_API_KEY_MAP[uiKey];
        apiDiff[apiKey || uiKey] = value;
    });
    return apiDiff;
};

// New users are provisioned with every notification enabled; used when
// GET /2.0/notification/settings returns 400 "no settings found for user".
export const defaultUiSettingsAllEnabled = () => Object.values(API_TO_UI_KEY_MAP)
    .reduce((acc, uiKey) => {
        acc[uiKey] = true;
        return acc;
    }, {});
